export default "__VITE_ASSET__D7jod5kV__"